var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('main',[_c('router-view',[_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c(_vm.CurrentComponent,{tag:"component"})],1)],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }